var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09939 6.01267L11.772 1.33996C12.076 1.03602 12.076 0.544591 11.772 0.240651C11.468 -0.0632898 10.9766 -0.0632898 10.6726 0.240651L5.99994 4.91336L1.32737 0.240651C1.02329 -0.0632898 0.532002 -0.0632898 0.228062 0.240651C-0.0760207 0.544591 -0.0760207 1.03602 0.228062 1.33996L4.90063 6.01267L0.228062 10.6854C-0.0760207 10.9893 -0.0760207 11.4807 0.228062 11.7847C0.379534 11.9363 0.578697 12.0125 0.777717 12.0125C0.976737 12.0125 1.17576 11.9363 1.32737 11.7847L5.99994 7.11198L10.6726 11.7847C10.8243 11.9363 11.0233 12.0125 11.2223 12.0125C11.4213 12.0125 11.6203 11.9363 11.772 11.7847C12.076 11.4807 12.076 10.9893 11.772 10.6854L7.09939 6.01267Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default ForwardRef;